module.exports = __webpack_public_path__ + "static/media/gitlab.b9278034.svg";